import nl from './education/NL';
import en from './education/EN';

export default {
  education: {
    nl,
    en,
  },
};
